'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('buffer'),
    Buffer = _require.Buffer;

var PeerId = require('peer-id');

var crypto = require('libp2p-crypto');

var debug = require('debug');

var log = debug('libp2p:secio');
log.error = debug('libp2p:secio:error');

var pbm = require('./secio.proto');

var support = require('../support');

var _require2 = require('libp2p-interfaces/src/crypto/errors'),
    UnexpectedPeerError = _require2.UnexpectedPeerError; // nonceSize is the size of our nonces (in bytes)


var nonceSize = 16;

exports.createProposal = function (state) {
  state.proposal.out = {
    rand: crypto.randomBytes(nonceSize),
    pubkey: state.key.local.public.bytes,
    exchanges: support.exchanges.join(','),
    ciphers: support.ciphers.join(','),
    hashes: support.hashes.join(',')
  };
  state.proposalEncoded.out = pbm.Propose.encode(state.proposal.out);
  return state.proposalEncoded.out;
};

exports.createExchange = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(state) {
    var res, selectionOut, sig;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return crypto.keys.generateEphemeralKeyPair(state.protocols.local.curveT);

          case 2:
            res = _context.sent;
            state.ephemeralKey.local = res.key;
            state.shared.generate = res.genSharedKey; // Gather corpus to sign.

            selectionOut = Buffer.concat([state.proposalEncoded.out, state.proposalEncoded.in, state.ephemeralKey.local]);
            _context.next = 8;
            return state.key.local.sign(selectionOut);

          case 8:
            sig = _context.sent;
            state.exchange.out = {
              epubkey: state.ephemeralKey.local,
              signature: sig
            };
            return _context.abrupt("return", pbm.Exchange.encode(state.exchange.out));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.identify = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(state, msg) {
    var pubkey, remoteId;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            log('1.1 identify');
            state.proposalEncoded.in = msg;
            state.proposal.in = pbm.Propose.decode(msg);
            pubkey = state.proposal.in.pubkey;
            state.key.remote = crypto.keys.unmarshalPublicKey(pubkey);
            _context2.next = 7;
            return PeerId.createFromPubKey(pubkey.toString('base64'));

          case 7:
            remoteId = _context2.sent;

            if (!state.id.remote) {
              _context2.next = 14;
              break;
            }

            if (!(state.id.remote.toString() !== remoteId.toString())) {
              _context2.next = 11;
              break;
            }

            throw new UnexpectedPeerError('Dialed to the wrong peer: IDs do not match!');

          case 11:
            state.id.remote.pubKey = state.key.remote;
            _context2.next = 15;
            break;

          case 14:
            state.id.remote = remoteId;

          case 15:
            log('1.1 identify - %s - identified remote peer as %s', state.id.local.toB58String(), state.id.remote.toB58String());

          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

exports.selectProtocols = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(state) {
    var local, remote, selected;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            log('1.2 selection');
            local = {
              pubKeyBytes: state.key.local.public.bytes,
              exchanges: support.exchanges,
              hashes: support.hashes,
              ciphers: support.ciphers,
              nonce: state.proposal.out.rand
            };
            remote = {
              pubKeyBytes: state.proposal.in.pubkey,
              exchanges: state.proposal.in.exchanges.split(','),
              hashes: state.proposal.in.hashes.split(','),
              ciphers: state.proposal.in.ciphers.split(','),
              nonce: state.proposal.in.rand
            };
            _context3.next = 5;
            return support.selectBest(local, remote);

          case 5:
            selected = _context3.sent;
            // we use the same params for both directions (must choose same curve)
            // WARNING: if they dont SelectBest the same way, this won't work...
            state.protocols.remote = {
              order: selected.order,
              curveT: selected.curveT,
              cipherT: selected.cipherT,
              hashT: selected.hashT
            };
            state.protocols.local = {
              order: selected.order,
              curveT: selected.curveT,
              cipherT: selected.cipherT,
              hashT: selected.hashT
            };

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x4) {
    return _ref3.apply(this, arguments);
  };
}();

exports.verify = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(state, msg) {
    var selectionIn, sigOk;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            log('2.1. verify');
            state.exchange.in = pbm.Exchange.decode(msg);
            state.ephemeralKey.remote = state.exchange.in.epubkey;
            selectionIn = Buffer.concat([state.proposalEncoded.in, state.proposalEncoded.out, state.ephemeralKey.remote]);
            _context4.next = 6;
            return state.key.remote.verify(selectionIn, state.exchange.in.signature);

          case 6:
            sigOk = _context4.sent;

            if (sigOk) {
              _context4.next = 9;
              break;
            }

            throw new Error('Bad signature');

          case 9:
            log('2.1. verify - signature verified');

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();

exports.generateKeys = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(state) {
    var secret, keys;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            log('2.2. keys');
            _context5.next = 3;
            return state.shared.generate(state.exchange.in.epubkey);

          case 3:
            secret = _context5.sent;
            state.shared.secret = secret;
            _context5.next = 7;
            return crypto.keys.keyStretcher(state.protocols.local.cipherT, state.protocols.local.hashT, state.shared.secret);

          case 7:
            keys = _context5.sent;

            if (!(state.protocols.local.order > 0)) {
              _context5.next = 13;
              break;
            }

            state.protocols.local.keys = keys.k1;
            state.protocols.remote.keys = keys.k2;
            _context5.next = 19;
            break;

          case 13:
            if (!(state.protocols.local.order < 0)) {
              _context5.next = 18;
              break;
            }

            // swap
            state.protocols.local.keys = keys.k2;
            state.protocols.remote.keys = keys.k1;
            _context5.next = 19;
            break;

          case 18:
            throw new Error('you are trying to talk to yourself');

          case 19:
            log('2.3. mac + cipher');
            _context5.next = 22;
            return Promise.all([state.protocols.local, state.protocols.remote].map(function (data) {
              return support.makeMacAndCipher(data);
            }));

          case 22:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function (_x7) {
    return _ref5.apply(this, arguments);
  };
}();

exports.verifyNonce = function (state, n2) {
  var n1 = state.proposal.out.rand;
  if (n1.equals(n2)) return;
  throw new Error("Failed to read our encrypted nonce: ".concat(n1.toString('hex'), " != ").concat(n2.toString('hex')));
};